// Components==============
import { faArrowLeft, faBars } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Shade from 'components/UI/Shade';
import { AnimatePresence, motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { framerFade } from 'utilities/framerAnimations';
import NavItems from '../NavItems/NavItems';
import './index.module.scss';
// =========================

export default function MobileMenu({ setLoginModalIsOpen }) {
    const { pathname } = useLocation();

    const [menuIsOpen, setMenuIsOpen] = useState(false);

    useEffect(() => {
        setMenuIsOpen(false);
    }, [pathname]);

    return (
        <div>
            <motion.div
                whileHover={{ scale: 0.95 }}
                styleName="button"
                onClick={() => setMenuIsOpen(true)}
            >
                <FontAwesomeIcon icon={faBars} />
            </motion.div>
            <AnimatePresence>
                {menuIsOpen && (
                    <>
                        <motion.div
                            animate={{ x: 0 }}
                            exit={{ x: -300 }}
                            initial={{ x: -300 }}
                            transition={{ damping: 5 }}
                            styleName="sideMenu"
                        >
                            <button
                                onClick={() => setMenuIsOpen(false)}
                                type="button"
                                styleName="back area1"
                            >
                                <FontAwesomeIcon icon={faArrowLeft} />
                            </button>
                            <div styleName="area3">
                                <NavItems
                                    mobile
                                    setLoginModalIsOpen={setLoginModalIsOpen}
                                />
                            </div>
                        </motion.div>
                        <motion.div {...framerFade}>
                            <Shade onClick={() => setMenuIsOpen(false)} />
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
        </div>
    );
}
